import { _get } from "../../../http";

export const getEstructurasCorporativo = (estructuraId) => _get(`/corporativos/${estructuraId}/obtenerEstructura`);

export const getEstructurasDistribucion = (estructuraId) => _get(`/distribuciones/${estructuraId}/obtenerEstructura`);

export const getEstructurasPlantel = (estructuraId) => _get(`/plantel/${estructuraId}/obtenerEstructura`);